/** @jsxImportSource @emotion/react */
import { keyframes } from "@emotion/react";
import defaultLoaderImagen from "../../images/loaderImagen.png";

const pulso = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.75);
    opacity: 0.35;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export default function Loader(props) {
  const imagen = props.loaderImagen || defaultLoaderImagen;
  const esChico = props.clases && props.clases.includes("chico");

  return (
    <div
      css={{
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <div
        css={{
          alignSelf: "center",
          marginTop: esChico ? "0px" : "120px"
        }}
      >
        <img
          css={{
            width: esChico ? "50px" : "100px",
            animation: `${pulso} 1.4s infinite ease-in-out`
          }}
          src={imagen}
          alt="loader"
        />
      </div>
      {props.children && (
        <div
          css={{
            marginTop: "20px",
            marginBottom: "20px",
            alignSelf: "center"
          }}
        >
          {props.children}
        </div>
      )}
    </div>
  );
}
